(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suppress-klaviyo-popup"]) return;
  try {
    
  (function() {
    var style = document.createElement("style");
    style.textContent = "div[data-testid='klaviyo-form-popup'], .klaviyo-form, .klaviyo-popup, div[class*='klaviyo'][class*='popup'], div[class*='klaviyo'][class*='form'], .needsclick.klaviyo-form { display: none !important; visibility: hidden !important; pointer-events: none !important; }";
    document.head.appendChild(style);
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains("klaviyo-form") || node.querySelector && node.querySelector(".klaviyo-form"))) {
            node.style.display = "none";
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Variant radio selection ── */
    document.querySelectorAll('.wholesale-gate__tier-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var card = this.closest('.wholesale-gate__product-card');
        if (!card) return;
        var hiddenInput = card.querySelector('.js-variant-id');
        if (hiddenInput) {
          hiddenInput.value = this.value;
        }
      });
    });

    /* ── Image dot carousel ── */
    document.querySelectorAll('.wholesale-gate__carousel-dots').forEach(function (dotsContainer) {
      var carousel = dotsContainer.closest('.wholesale-gate__carousel');
      if (!carousel) return;

      var slides = carousel.querySelectorAll('.wholesale-gate__carousel-slide');
      var dots = dotsContainer.querySelectorAll('.wholesale-gate__carousel-dot');

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(this.getAttribute('data-slide-index'), 10);

          slides.forEach(function (slide) {
            slide.classList.remove('is-active');
          });
          dots.forEach(function (d) {
            d.classList.remove('is-active');
          });

          if (slides[index]) {
            slides[index].classList.add('is-active');
          }
          this.classList.add('is-active');
        });
      });
    });

    /* ── Hover: show second image ── */
    document.querySelectorAll('.wholesale-gate__carousel').forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.wholesale-gate__carousel-slide');
      var dots = carousel.querySelectorAll('.wholesale-gate__carousel-dot');
      if (slides.length < 2) return;

      function showSlide(index) {
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }

      carousel.addEventListener('mouseenter', function () {
        showSlide(1);
      });

      carousel.addEventListener('mouseleave', function () {
        showSlide(0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-gate"] && !Shopify.designMode) return;
  try {
    
  /* Force login button navigation (Shopify's customer accounts script can intercept and block it) */
  document.addEventListener('click', function(e) {
    var loginBtn = e.target.closest('a.wholesale-gate__login-link[href*="customer_authentication"], a.wholesale-gate__login-link[href*="storefront_login"]');
    if (loginBtn) {
      e.stopImmediatePropagation();
      window.location.href = loginBtn.href;
    }
  }, true);

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('wholesale-order-variant')) return;
    const card = e.target.closest('.wholesale-gate__product-card');
    if (!card) return;
    const option = e.target.selectedOptions[0];
    const variantInput = card.querySelector('.wholesale-gate__variant-id');
    if (variantInput) variantInput.value = e.target.value;
    const quantity = card.querySelector('[name="quantity"]');
    if (quantity) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
    }
    card.querySelectorAll('.wholesale-order-price-option').forEach(function(prices) {
      prices.hidden = prices.dataset.variantId !== e.target.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-product-access"]) return;
  try {
    
  (function() {
    var gate = document.getElementById("wholesale-access-block");
    if (!gate) return;
    if (gate.dataset.wholesale === "true") return;
    var section = gate.closest("[id^=shopify-section]");
    if (section) {
      var sibling = section.nextElementSibling;
      while (sibling) {
        sibling.style.display = "none";
        sibling = sibling.nextElementSibling;
      }
    }
    var meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
  })();

  /* Inject "(credit fee)" before variant price for sample kit */
  (function() {
    function injectCreditFee() {
      /* Walk every element on the page looking for a price (€) near "Sample Kit" */
      var allEls = document.querySelectorAll('span, div, p, label, td, li');
      for (var i = 0; i < allEls.length; i++) {
        var el = allEls[i];
        var text = el.textContent || '';
        /* Find elements that contain a price like €10 and are near a "Sample Kit" context */
        if (text.match(/€\s*15/) && el.children.length === 0 && text.indexOf('credit fee') === -1) {
          /* Check if a parent or sibling mentions "Sample Kit" */
          var ctx = el.closest('label, fieldset, div, li, tr');
          if (ctx && ctx.textContent.indexOf('Sample Kit') !== -1) {
            var tag = document.createElement('span');
            tag.textContent = '(credit fee) ';
            tag.style.cssText = 'font-weight:400;opacity:0.55;font-size:0.9em;';
            el.parentNode.insertBefore(tag, el);
          }
        }
      }
    }
    /* Run after DOM settles — variant picker may render async */
    setTimeout(injectCreditFee, 500);
    setTimeout(injectCreditFee, 1500);
    setTimeout(injectCreditFee, 3000);
  })();

  if (window.location.pathname.indexOf("wholesale") !== -1) {
    var style = document.createElement("style");
    style.textContent = "div[data-testid='klaviyo-form-popup'], .klaviyo-form, .klaviyo-popup, div[class*='klaviyo'][class*='popup'], div[class*='klaviyo'][class*='form'] { display: none !important; visibility: hidden !important; }";
    document.head.appendChild(style);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-sample-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'bm_sample_popup';
    var dlg = document.getElementById('bm-sample-dialog');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var fab = document.getElementById('bm-sample-fab');
    var form = dlg.querySelector('form');
    var state = null, submitted = false;
    try { state = localStorage.getItem(KEY); } catch (e) {}
    try { submitted = sessionStorage.getItem(KEY + '_submitted') === '1'; } catch (e) {}
    var posted = !!dlg.querySelector('[data-bm-posted]');

    function open() { if (!dlg.open) dlg.showModal(); }
    function close() { if (dlg.open) dlg.close(); }
    function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

    if (posted && submitted) {
      try { sessionStorage.removeItem(KEY + '_submitted'); } catch (e) {}
      remember('sent');
      state = 'sent';
      dlg.classList.add('bm-sample--sent');
      var gateOk = document.querySelector('.wholesale-gate__success');
      if (gateOk) gateOk.hidden = true;
      open();
    } else if (state === 'sent') {
      /* nothing: samples already requested from this browser */
    } else {
      if (fab) fab.hidden = false;
      if (state !== 'dismissed') {
       // setTimeout(open, (parseInt(dlg.dataset.delay, 10) || 0) * 1000);
      }
    }

    dlg.addEventListener('close', function () {
      if (state !== 'sent') { remember('dismissed'); state = 'dismissed'; }
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close();
      if (e.target.closest('[data-bm-close]')) close();
    });
    if (fab) fab.addEventListener('click', open);
    if (form) form.addEventListener('submit', function () {
      try { sessionStorage.setItem(KEY + '_submitted', '1'); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
